import { createAction, props } from '@ngrx/store';
import { PageDto } from '../api/core';
import { CreateFirmwareDto, FirmwareActionTypes } from './firmwares.models';

export const loading = createAction(FirmwareActionTypes.LOADING);
export const loadingDone = createAction(FirmwareActionTypes.LOADING_DONE);
export const loadFirmwares = createAction(FirmwareActionTypes.LOAD_FIRMWARES);
export const loadedFirmwares = createAction(FirmwareActionTypes.LOADED_FIRMWARES, props<{ data: PageDto }>());
export const addFirmware = createAction(FirmwareActionTypes.ADD_FIRMWARE, props<{ firmware: CreateFirmwareDto }>());
export const releaseFirmware = createAction(FirmwareActionTypes.RELEASE_FIRMWARE, props<{ id: number }>());
export const deleteFirmware = createAction(FirmwareActionTypes.DELETE_FIRMWARE, props<{ id: number }>());
